//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import timezones from '~/data/timezones.json'

export default {
  name: 'ModalSettings',
  data() {
    return {
      //timezones: timezones,
      currentLocale: null,
      showTimezone: false,
      showLanguage: false,      
    }
  },
  computed: {
    timezones() {
      if(!_.includes(_.map(timezones, 'zone'), this.$store.state.settings.timezone)) {
        let tmp = {
          "zone": this.$store.state.settings.timezone,
          "gmt": "",
          "name": this.$store.state.settings.timezone
        }
        return _.concat([tmp], timezones)
      }
      return timezones;
    },
    availableLocales() {
      return this.$i18n.locales
    },
    oddsFormat() {
      return this.$store.state.settings.oddsFormat
    },
    acceptOdds() {
      return this.$store.state.settings.acceptOdds
    },
    timezone: {
      get() {
        return this.$store.state.settings.timezone
      },
      set(value) {
        this.$store.commit('settings/setTimezone', value)
      }
    },
  },
  created() {
    this.opened()
  },
  methods: {
    opened() {
      this.currentLocale = this.$i18n.locale
    },
    close() {
      this.$modal.hide('modal-settings')
    },
    setOddsFormat(value) {
      this.$store.commit('settings/setOddsFormat', value)
    },
    setAcceptOdds(value) {
      this.$store.commit('settings/setAcceptOdds', value)
    },
    setLanguage(src) {
      this.currentLocale = src.target.value
    },
    setTimezone(event) {


      //console.log('setTimezone', event.target.value);
      //console.log(this.$date());
      ///console.log(this.$date.tz);
      //this.$store.commit('settings/setTimezone', event.target.value)

    },
    save() {
      if(this.showLanguage && this.currentLocale !== this.$i18n.locale) {
        this.$i18n.setLocale(this.currentLocale)
        window.localStorage.setItem('app_lang', this.currentLocale); //store in local storage for the app
        setTimeout(() => {
          this.$router.push(this.localePath('/'))
          this.$root.$emit('update_lang')
        }, 300)
      }
      this.$modal.hide('modal-settings')
    }
  }
}
